import isSafari from '@braintree/browser-detection/is-safari'

/**
 * Request clipboard write access
 * @param {string} scope Scope Requested
 * @throws Error if no clipboard access
 */
const requestClipboardAccess = async (scope) => {
  if (isSafari()) {
    return true
  } else {
    const permissionResults = await navigator.permissions.query({ name: scope })

    return (
      permissionResults.state === 'granted' ||
      permissionResults.state === 'prompt'
    )
  }
}

const clipboard = {
  /**
   * Read Data from clipboard
   * @throws Error on clipboard read
   */
  readFromClipboard: async () => {
    if (await requestClipboardAccess('clipboard-read')) {
      return navigator.clipboard.readText()
    }

    return null
  },

  /**
   * Copy Data To Clipboard
   * @param {string} dataToCopy Data to copy to clipboard
   * @throws Error on clipboard write error
   */
  writeToClipboard: async (dataToCopy) => {
    if (await requestClipboardAccess('clipboard-write')) {
      await navigator.clipboard.writeText(dataToCopy)
    }
  },
}

export { clipboard }
